export const APP_VERSION = '1.1.5';
export const VERSION_MAJOR = 1;
export const VERSION_MINOR = 1;
export const VERSION_PATCH = 5;